import InternationalDocumentRepository from "../api/internationalDocument";

class InternationalDocumentUseCase {
    constructor() {
        this.repository = new InternationalDocumentRepository();
    }

    async getDetail(destinationCityCode) {
        return this.repository.getDetail(destinationCityCode);
    }

    /**
     * Map API DTO → entity flags. Null/undefined → false.
     */
    mapFlags(dto) {
        if (!dto) {
            return {
                is_receiver_email: false,
                is_identity_number: false,
                is_tax_identification_number: false,
                is_ktp_image: false,
                is_npwp_image: false,
                is_before_and_after_packing_image: false,
                is_other_commodity: false,
            };
        }

        return {
            is_receiver_email: !!dto.is_receiver_email,
            is_identity_number: !!dto.is_identity_number,
            is_tax_identification_number: !!dto.is_tax_identification_number,
            is_ktp_image: !!dto.is_ktp_image,
            is_npwp_image: !!dto.is_npwp_image,
            is_before_and_after_packing_image: !!dto.is_before_and_after_packing_image,
            is_other_commodity: !!dto.is_other_commodity,
        };
    }

    /**
     * True when flags mark CIPL as required for the destination.
     * Unknown flags (null/undefined) → treated as required (conservative: block
     * doc-less interpack rows rather than let them through).
     */
    isCiplRequired(flags) {
        return flags ? Object.values(flags).some(Boolean) : true;
    }

    /**
     * Parity CA: all flags false → document not required, completeness auto-true.
     */
    isAllFlagsFalse(flags) {
        if (!flags) return true;
        return !Object.values(flags).some(Boolean);
    }
}

export default new InternationalDocumentUseCase();
